import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecord: RouteRecordRaw[] = [
  {
    name: 'client.communication.calendar',
    path: 'calendar',
    component: () => import('src/client/pages/ClientCalendar.vue'),
    meta: {
      roles: [Roles.Client],
      featureFlag: 'calendar',
    },
  },
  {
    name: 'client.communication.agreements',
    path: 'agreements',
    component: () => import('src/client/pages/ClientAgreements.vue'),
    meta: {
      roles: [Roles.Client],
    },
  },
  {
    name: 'client.communication.emails',
    path: 'emails',
    component: () => import('src/client/pages/ClientEmailHistory.vue'),
    meta: {
      roles: [Roles.Client],
    },
  },
]

export default routeRecord
